import React, { useEffect, useState } from 'react';

import { TransactionList } from '@eika/transaction-list';

import AccountViewWrapper from '../../components/AccountView/AccountViewWrapper';
import AccountBalanceWrapper from '../../components/AccountView/balance/AccountBalanceWrapper';
import { AccountViewHeader } from '../../components/AccountViewHeader';
import AccountViewHeaderSkeleton from '../../components/AccountViewHeader/AccountViewHeaderSkeleton';
import DemoActions from './components/DemoActions';
import { favoriteAccount, transactions } from './demoData';

const DemoDetails: React.FC = () => {
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => setLoading(false), 1000);
    }, []);

    return (
        <>
            {isLoading && (
                <div className="account-view-header skeleton">
                    <AccountViewHeaderSkeleton />
                </div>
            )}
            {!isLoading && (
                <div className="account-view-header">
                    <AccountViewHeader account={favoriteAccount} />
                </div>
            )}
            <AccountViewWrapper useTabs={false} onChangeValue={() => null} className="sgw-account-details">
                <dl className="sgw-account-details__wrapper">
                    <AccountBalanceWrapper account={favoriteAccount} />
                </dl>
                <DemoActions className="account-view__actions-wrapper" />
            </AccountViewWrapper>

            <TransactionList transactions={transactions} reservedText="Reserved" />
        </>
    );
};

export default DemoDetails;
